import { LitElement, html, svg } from 'lit';

export class IconUpload32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Pil opp fra harddisk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.001 21V5M10.06 10.942 16.002 5l5.942 5.942M31.001 21.18V23a4 4 0 0 1-4 4h-22a4 4 0 0 1-4-4v-1.82"></path></svg>`; }
}
if (!customElements.get('f-icon-upload32', IconUpload32)) {
  customElements.define('f-icon-upload32', IconUpload32);
}